import React from 'react'
import PropTypes from 'prop-types'
import TinyPopover from 'components/Utils/TinyPopover'

export default class PopoverOnHover extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    position: PropTypes.string.isRequired,
    delayShow: PropTypes.number.isRequired,
    transitionDuration: PropTypes.number,
    containerStyle: PropTypes.object,
  }

  static defaultProps = {
    delayShow: 0,
    transitionDuration: 0.25,
    containerStyle: {},
  }

  state = {
    isOpen: false,
  }
  componentWillReceiveProps({ content, ...props }) {
    if (content !== this.props.content) {
      this.close()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  render() {
    return (
      <TinyPopover
        isOpen={this.state.isOpen}
        transitionDuration={this.props.transitionDuration}
        position={this.props.position}
        content={this.props.content}
        // overrides default `overflow: hidden`, allowing box-shadows to be visible
        containerStyle={{
          overflow: 'visible',
          zIndex: 13,
          ...this.props.containerStyle,
        }}
        className={this.props.className}
      >
        {React.cloneElement(React.Children.only(this.props.children), {
          onMouseOver: this.open,
          onMouseOut: this.close,
        })}
      </TinyPopover>
    )
  }

  open = () => {
    this.timeout = setTimeout(() => {
      this.setState({ isOpen: true })
    }, this.props.delayShow)
  }

  close = () => {
    clearTimeout(this.timeout)
    if (this.state.isOpen) {
      this.setState({ isOpen: false })
    }
  }
}
